import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";
import {FilterBarModuleController} from "../filter-bar-module.controller";

export class FilterBarModuleProps extends BaseModuleProps {
  controller: FilterBarModuleController;
}
